import React from 'react'
import Label from '../label'
import Input from '../input'
import Button from '../button'
import Slider from '../slider'
import CaratWeightSlider from '../carat-weight-slider'
import PriceSlider from '../price-slider'
import Spacer from '../spacer'
import Checkbox from '../checkbox'
import Select from '../select'
import PrimaryDiamondShapes from '../select-shapes/shapes'
import SelectItem from '../select-item'
import { Grid, GridItem } from '../grid'
import SelectMulti from '../select-multi'
import SelectShapes from '../select-shapes'
import RefreshIcon from 'react-icons/lib/fa/refresh'
import ToggleDisplay from '../toggle-display'
import css from './style.css'
import _keys from 'lodash/keys'
import {
  ColorMarkers,
  ClarityMarkers,
  FluorescenceIntensityMarkers,
  FancyIntensityMarkers,
  CutMarkers,
  PolishMarkers,
  SymmetryMarkers
} from '../../utils/slider-markers'
import {
  DepthPercentageSlider,
  TablePercentageSlider,
  LWRatioSlider,
  SizeSlider
} from '../../utils/slider-configs'

const SearchFilters = (props) => {
  const onChangeVal = (key, val) => {
    if (!props.onChangeVal) {
      return
    }
    props.onChangeVal(key, val)
  }

  const onChangeInput = (key, e) => {
    onChangeVal(key, e.target.value)
  }

  const onChangeCheckbox = (key, e) => {
    onChangeVal(key, e.target.checked)
  }

  return (
    <div>
      <Grid>
        <GridItem col='1/2'>
          <Label>
            Shape
          </Label>
          <SelectShapes
            listFor={'diamond_search'}
            shapes={PrimaryDiamondShapes}
            value={props.shapes}
            onChange={onChangeVal.bind(this, 'shapes')} />
        </GridItem>
        <GridItem col='1/2'>
          <Grid>
            <GridItem col='3/4'>
              <Label>
                Price
              </Label>
            </GridItem>
            <GridItem col='1/4'>
              <SelectItem
                sm
                options={[
                  {value: 'each', label: 'each'},
                  {value: 'carat', label: 'carat'}
                ]}
                value={props.priceUnit}
                onChange={onChangeVal.bind(this, 'priceUnit')} />
            </GridItem>
          </Grid>
          <PriceSlider
            value={props.price}
            onChange={onChangeVal.bind(this, 'price')} />
        </GridItem>
        <Spacer xxs />
      </Grid>
      <Grid>
        <GridItem col='1/2'>
          <Grid>
            <GridItem col='3/4'>
              <Label>
                Size
              </Label>
            </GridItem>
            <GridItem col='1/4'>
              <SelectItem
                sm
                options={[
                  {value: 'carat', label: 'carat'},
                  {value: 'mm', label: 'mm'}
                ]}
                value={props.sizeUnit}
                onChange={onChangeVal.bind(this, 'sizeUnit')} />
            </GridItem>
          </Grid>
          {props.sizeUnit === 'carat' &&
            <CaratWeightSlider
              value={props.weight}
              onChange={onChangeVal.bind(this, 'weight')} />}
          {props.sizeUnit === 'mm' &&
            <Slider
              className={props.sizeUnit !== 'mm' ? css.hidden : ''}
              double
              inputs
              labelRight='mm'
              min={SizeSlider.min}
              max={SizeSlider.max}
              step={SizeSlider.step}
              minDistance={SizeSlider.minDistance}
              value={props.size}
              onChange={onChangeVal.bind(this, 'size')} />}
        </GridItem>
        <GridItem col='1/2'>
          <Grid>
            <GridItem col='3/4'>
              <Label>
                Colour
              </Label>
            </GridItem>
            <GridItem col='1/4'>
              <SelectItem
                sm
                options={[
                  {value: 'regular', label: 'regular'},
                  {value: 'fancy', label: 'fancy'}
                ]}
                value={props.colourType}
                onChange={onChangeVal.bind(this, 'colourType')} />
            </GridItem>
          </Grid>
          <Slider
            className={props.colourType !== 'regular' ? css.hidden : ''}
            double
            min={0}
            max={9}
            markers={_keys(ColorMarkers)}
            value={props.colour}
            onChange={onChangeVal.bind(this, 'colour')} />
          <SelectMulti
            className={props.colourType !== 'fancy' ? css.hidden : ''}
            options={[
              {value: 'Yellow', label: 'YEL'},
              {value: 'Pink', label: 'PIN'},
              {value: 'Blue', label: 'BLU'},
              {value: 'Orange', label: 'ORA'},
              {value: 'Green', label: 'GRE'},
              {value: 'Brown', label: 'BRO'},
              {value: 'Red', label: 'RED'},
              {value: 'Gray', label: 'GRA'},
              {value: 'Purple', label: 'PUR'},
              {value: 'Violet', label: 'VIO'},
              {value: 'Chameleon', label: 'CHA'},
              {value: 'White', label: 'WHI'},
              {value: 'Black', label: 'BLA'}
            ]}
            value={props.colourFancy}
            onChange={onChangeVal.bind(this, 'colourFancy')} />
          <ToggleDisplay show={props.colourType === 'fancy'}>
            <Label>
              Fancy Intensity
            </Label>
            <Slider
              double
              min={0}
              max={9}
              markers={_keys(FancyIntensityMarkers)}
              value={props.fancyIntensity}
              onChange={onChangeVal.bind(this, 'fancyIntensity')} />
          </ToggleDisplay>
        </GridItem>
        <Spacer xxs />
      </Grid>
      <Grid>
        <GridItem col='1/2'>
          <Label>
            Cut
          </Label>
          <Slider
            double
            min={0}
            max={6}
            markers={_keys(CutMarkers)}
            value={props.cut}
            onChange={onChangeVal.bind(this, 'cut')} />
        </GridItem>
        <GridItem col='1/2'>
          <Label>
            Clarity
          </Label>
          <Slider
            double
            min={0}
            max={12}
            markers={_keys(ClarityMarkers)}
            value={props.clarity}
            onChange={onChangeVal.bind(this, 'clarity')} />
        </GridItem>
        <Spacer xs />
      </Grid>
      <Grid>
        <GridItem col='1/2'>
          <Label>
            Polish
          </Label>
          <Slider
            double
            min={0}
            max={6}
            markers={_keys(PolishMarkers)}
            value={props.polish}
            onChange={onChangeVal.bind(this, 'polish')} />
        </GridItem>
        <GridItem col='1/2'>
          <Label>
            Symmetry
          </Label>
          <Slider
            double
            min={0}
            max={6}
            markers={_keys(SymmetryMarkers)}
            value={props.symmetry}
            onChange={onChangeVal.bind(this, 'symmetry')} />
        </GridItem>
        <Spacer xs />
      </Grid>
      <Grid>
        <GridItem col='1/2'>
          <Label>
            Fluorescence
          </Label>
          <Slider
            double
            min={0}
            max={7}
            markers={_keys(FluorescenceIntensityMarkers)}
            value={props.fluorescence}
            onChange={onChangeVal.bind(this, 'fluorescence')} />
        </GridItem>
        <GridItem col='1/4'>
          <Label>&nbsp;</Label>
          <Button onClick={props.onClickReset}>
            <RefreshIcon />&nbsp;Reset All
          </Button>
        </GridItem>
        <GridItem col='1/4' />
        <Spacer sm />
      </Grid>
      <Grid>
        <GridItem col='1/2'>
          <Button onClick={props.onToggleAdvanced.bind(this, props.advancedShown)} alt>
            {props.advancedShown ? 'Hide' : 'Show'} Advanced Criteria
          </Button>
        </GridItem>
        <Spacer xs />
        <div className={!props.advancedShown ? css.hidden : ''}>
          <GridItem col='1/3'>
            <Label>
              Depth %
            </Label>
            <Slider
              double
              inputs
              labelRight='%'
              min={DepthPercentageSlider.min}
              max={DepthPercentageSlider.max}
              step={DepthPercentageSlider.step}
              value={props.depth}
              onChange={onChangeVal.bind(this, 'depth')} />
          </GridItem>
          <GridItem col='1/3'>
            <Label>
              Table %
            </Label>
            <Slider
              double
              inputs
              labelRight='%'
              min={TablePercentageSlider.min}
              max={TablePercentageSlider.max}
              step={TablePercentageSlider.step}
              value={props.table}
              onChange={onChangeVal.bind(this, 'table')} />
          </GridItem>
          <GridItem col='1/3'>
            <Label>
              L/W
            </Label>
            <Slider
              double
              inputs
              labelRight=':1'
              minDistance={LWRatioSlider.minDistance}
              min={LWRatioSlider.min}
              max={LWRatioSlider.max}
              step={LWRatioSlider.step}
              value={props.ratio}
              onChange={onChangeVal.bind(this, 'ratio')} />
          </GridItem>
          <Spacer xs />
          <GridItem col='1/2'>
            <Grid>
              <GridItem col='2/4'>
                <Label>
                  Supplier Type
                </Label>
                <div className={css.inlineSelectContainer}>
                  <SelectMulti options={[
                    {value: 'primary', label: 'Primary'},
                    {value: 'preferred', label: 'Preferred'},
                    {value: 'other', label: 'Other'}
                  ]} value={props.supplierTypes} onChange={onChangeVal.bind(this, 'supplierTypes')} />
                  <SelectItem options={[
                    {value: 'all', label: 'All'}
                  ]} value={props.supplierTypes.length === 0 ? 'all' : ''} onChange={onChangeVal.bind(this, 'supplierTypes', [])} />
                </div>
              </GridItem>
              <GridItem col='2/4'>
                <Label>
                  Search by Grading Report Number(s)
                </Label>
                <Input value={props.labreports} placeholder='Grading Report Number' onChange={onChangeInput.bind(this, 'labreports')} />
              </GridItem>
            </Grid>
          </GridItem>
          <GridItem col='1/2'>
            <Grid>
              <GridItem col='2/4'>
                <Label>
                  Search by Stock Number(s)
                </Label>
                <Input placeholder='Stock Number' value={props.serialnumbers} onChange={onChangeInput.bind(this, 'serialnumbers')} />
              </GridItem>
              <GridItem col='2/4' />
            </Grid>
          </GridItem>
          <Spacer xs />
          <GridItem col='1/2'>
            <Grid>
              <GridItem col='2/4'>
                <Label>
                  Supplier(s)
                </Label>
                <Select
                  multi
                  value={props.suppliers}
                  options={props.suppliersList}
                  onChange={onChangeVal.bind(this, 'suppliers')}
                />
              </GridItem>
              <GridItem col='2/4'>
                <Label>
                  Grading Lab
                </Label>
                <SelectMulti
                  options={[
                    {value: 'GIA', label: 'GIA'},
                    {value: 'AGS', label: 'AGS'},
                    {value: 'IGI', label: 'IGI'},
                    {value: 'HRD', label: 'HRD'},
                    {value: 'Other', label: 'Other'}
                  ]}
                  value={props.gradingreports}
                  onChange={onChangeVal.bind(this, 'gradingreports')} />
              </GridItem>
            </Grid>
          </GridItem>
          <GridItem col='1/4'>
            <Label>
              Photo
            </Label>
            <Checkbox formBlock checked={props.withImage} onChange={onChangeCheckbox.bind(this, 'withImage')}>
              Only show diamonds with photos
            </Checkbox>
          </GridItem>
          <GridItem col='1/4'>
            <Label>
              Origin
            </Label>
            <Checkbox formBlock checked={props.canadaorigin} onChange={onChangeCheckbox.bind(this, 'canadaorigin')}>
              Canadian
            </Checkbox>
          </GridItem>
          <Spacer xs />
          <GridItem col='1/2'>
            <Label>
              Location
            </Label>
            <Select
              multi
              value={props.locations}
              options={[
                {value: 'Belgium', label: 'Belgium'},
                {value: 'Canada', label: 'Canada'},
                {value: 'Hong Kong', label: 'Hong Kong'},
                {value: 'India', label: 'India'},
                {value: 'Israel', label: 'Israel'},
                {value: 'UAE', label: 'UAE'},
                {value: 'United Kingdom', label: 'United Kingdom'},
                {value: 'USA', label: 'USA'}
              ]}
              onChange={onChangeVal.bind(this, 'locations')}
              disabled={false}
            />
          </GridItem>
          <GridItem col='1/4'>
            <Label>
              Matched Sets
            </Label>
            <Checkbox formBlock checked={props.matchedsets} onChange={onChangeCheckbox.bind(this, 'matchedsets')}>
              Only show matched sets
            </Checkbox>
          </GridItem>
          <GridItem col='1/4'>
            <Label>Diamond Type</Label>
            <SelectItem
              sm
              options={[
                { value: 'natural', label: 'Natural' },
                { value: 'lgd', label: 'Lab Grown' },
              ]}
              value={props.diamondType}
              onChange={onChangeVal.bind(this, 'diamondType')}
            />
          </GridItem>
        </div>
        <Spacer sm />
      </Grid>
    </div>
  )
}

export default SearchFilters



// WEBPACK FOOTER //
// ./src/components/search-filters/index.js